import { getDentalCorpBackend } from '../commons/backend/dentalCorpBackendProxy';
import { history } from '../commons/utils';
import { purgeState } from './commonActions';
const dentalCorpBackend = getDentalCorpBackend();

export const updatePassword = (curPswd, newPswd) => {
	return async (dispatch, getState) => {
		let body = {
			password: curPswd,
			newPassword: newPswd,
		};
		return dentalCorpBackend.updateUser(getState(), body, dispatch);
	};
};

export const logout = () => {
	return async (dispatch, getState) => {
		await dentalCorpBackend.logoutUser(getState(), dispatch);
		dispatch(purgeState());
		history.push('/');
	};
};
